import {
  Component,
  OnInit,
  ChangeDetectorRef,
  Input,
  ViewChild,
  ElementRef,
  Output,
  ɵConsole,
  TemplateRef,
  HostListener,
} from "@angular/core";
import { NgbTooltipConfig, NgbTooltip } from "@ng-bootstrap/ng-bootstrap";
import { ViewfileComponent } from "src/app/components/viewfile/viewfile.component";
import { SearchResultsService } from "src/app/views/searchresults/searchresults.service";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatTableDataSource } from "@angular/material/table";
import { ConfirmationDialogComponent } from "src/app/components/confirmation-dialog/confirmation-dialog.component";
import { SearchTypeModel, AttachmentInfoModel } from "src/app/Models/AttachmentInfo.model";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { ProjectService } from "../projects/services/projectservice.service";
import { MailRequestModel } from "src/app/Models/mailRequestModel.model";
import { Router, ActivatedRoute } from "@angular/router";
import { SearchPageService } from "../searchpage/searchpage.service";
import { isArray } from "util";
import { forkJoin, of, throwError, Observable } from "rxjs";
import * as JSZip from "jszip";
import { InfoDialogComponent } from "src/app/components/info-dialog/info-dialog.component";
import { catchError, map, tap, mergeMap } from "rxjs/operators";
import { trigger, transition, style, animate } from "@angular/animations";
import { OrganizationService } from "src/app/services/Organization/organization.service";
declare var $: any;
import { AuthServiceService } from "src/app/services/auth-service.service";
import { EventEmitter } from "@angular/core";
import { GraphService } from "src/app/services/Organization/graph.service";
import { DomSanitizer } from "@angular/platform-browser";
import { EmailFileModel, FileInfoModel } from "src/app/Models";
import { ToastrService } from "ngx-toastr";
import { UserRoles } from "src/app/enums/userRoles.enum";
import { auto } from "@popperjs/core";
@Component({
  selector: "app-searchresults",
  templateUrl: "./searchresults.component.html",
  styleUrls: ["./searchresults.component.css"],
  animations: [
    trigger("fadeInOut", [
      transition(":enter", [
        // :enter is alias to 'void => *'
        style({ opacity: 0 }),
        animate(500, style({ opacity: 1 })),
      ]),
      transition(":leave", [
        // :leave is alias to '* => void'
        animate(250, style({ opacity: 0 })),
      ]),
    ]),
  ],
})
export class SearchresultsComponent implements OnInit {
  @Input() projectsView: string;
  public from: number = 0;
  public size: number = 9;
  @Output() demo = new EventEmitter();
  @ViewChild("tooltip") public tooltip: NgbTooltip;
  @ViewChild('myInfoDialog') infoDialog = {} as TemplateRef<string>;
  public searchResults: AttachmentInfoModel[];
  public loading = false;
  public getSelectedFileRequests = [];
  public groupedSearchResults: any[] = [];
  public CaseStudy: string;
  public selectedFiles = [];
  public overflow = false;
  public flag: boolean = true;
  extractedString1: string
  userOrgID: string = this.auth.getOrganizationId();
  public selectedorganization: any = { id: this.userOrgID };
  public threshold = 5;

  public categoryList = [
    {
      name: "Case Studies",
      iconUrl: "Case_studies.svg",
      description:
        " Briefs on real-world applications of ACS’ services and solutions, and the resultant business benefits. ",
      iconBGColor: "#EFEFFD",
      data: "Case Studies",
    },
    {
      name: "Corporate Decks",
      iconUrl: "corporate_decks.svg",
      description:
        "High-level overview of ACS – the company, its history, experience, capabilities, and specializations.",
      iconBGColor: "#E6FAF3",
      data: "Corporate Deck",
    },
    {
      name: "Industry Decks",
      iconUrl: "industries_decks.svg",
      description:
        "ACS’ capabilities, solutions, services, and relevant case studies illustrated through industry-specific decks.",
      iconBGColor: "#FFEFED",
      data: "Industry Deck",
    },
    {
      name: "Artifactory",
      iconUrl: "templates.svg",
      description:
        "Downloadable pre-approved standard case study templates to be used for the creation of new case studies.",
      iconBGColor: "#EFEFFD",
      data: "Artifactory",
    },
  ];
  public attachedIds = [];
  private mainUrl = environment.mainUrl;
  public role: string;
  private searchConfig: SearchTypeModel;
  @ViewChild("attachmentId") attachmentId: ElementRef;
  @ViewChild("closeId") closeId: ElementRef;
  @ViewChild("actions") actions: ElementRef;
  private searchTerm: string;
  private selectedFilters: any;
  private groupBy: string;
  private operator: boolean;
  private activeProjectsFilter: boolean;
  public mailMultipleAttachments: string[];
  public selectAllDivFlag: boolean;
  public searchResultsViewFlag: boolean = false;
  groupSearchFlag = false;
  public verticalOption: string;
  public verticalOptions = [
    "Airlines & Aviation",
    "Automobile",
    "BFSI",
    "Biotechnology",
    "Consulting",
    "E-Commerce",
    "Education",
    "Energy & Utilities",
    "Engineering",
    "Healthcare",
    "Human Resources",
    "Information Technology",
    "International Trade & Development",
    "Legal",
    "Logistics & Transportation",
    "Manufacturing",
    "Media & Entertainment",
    "Non-profit Organization",
    "Retail",
    "Sales & Marketing",
    "Telecom",
    "Travel & Hospitality",
  ];

  public verticalOptionsFlag = false;
  public Options = [
    {
      name: "Airlines & Aviation",
      image: "assets/images/Airline_and_Aviation.png",
      count: 0,
    },
    {
      name: "Automobile",
      image: "assets/images/Automobile.png",
      count: 0,
    },
    {
      name: "BFSI",
      image: "assets/images/BFSI.png",
      count: 0,
    },
    {
      name: "Biotechnology",
      image: "assets/images/biotech.jpg",
      count: 0,
    },
    {
      name: "Consulting",
      image: "assets/images/consulting.png",
      count: 0,
    },
    {
      name: "E-commerce",
      image: "assets/images/Commerce.png",
      count: 0,
    },

    {
      name: "Education",
      image: "assets/images/Education.png",
      count: 0,
    },
    {
      name: "Energy & Utilities",
      image: "assets/images/Energy_Utilities.png",
      count: 0,
    },
    {
      name: "Engineering",
      image: "assets/images/Engineering.png",
      count: 0,
    },
    {
      name: "Healthcare",
      image: "assets/images/Health_care.png",
      count: 0,
    },
    {
      name: "Human Resources",
      image: "assets/images/Human_Resources.png",
      count: 0,
    },

    {
      name: "Information Technology",
      image: "assets/images/Information_Technology.png",
      count: 0,
    },
    {
      name: "International Trade & Development",
      image: "assets/images/International_Trade_&_Development.png",
      count: 0,
    },
    {
      name: "Legal",
      image: "assets/images/Legal.png",
      count: 0,
    },
    {
      name: "Logistics & Transportation",
      image: "assets/images/logositics_transportation.png",
      count: 0,
    },

    {
      name: "Manufacturing",
      image: "assets/images/Manufacturing.png",
      count: 0,
    },

    {
      name: "Media & Entertainment",
      image: "assets/images/media_and_entertainment.png",
      count: 0,
    },
    {
      name: "Non-profit Organization",
      image: "assets/images/Non-profit_Organization.png",
      count: 0,
    },
    {
      name: "Retail",
      image: "assets/images/Retail.png",
      count: 0,
    },
    {
      name: "Sales & Marketing",
      image: "assets/images/Sales_&_Marketing.png",
      count: 0,
    },
    {
      name: "Telecom",
      image: "assets/images/telecom.png",
      count: 0,
    },

    {
      name: "Travel & Hospitality",
      image: "assets/images/Travel_and_Hospitality.png",
      count: 0,
    },
  ];

  slideConfig = {
    slidesToShow: 4,
    slidesToScroll: 4,
    method: {},
    speed: 300,
    focusOnSelect: false,
    swipe: true,
    centerPadding: "25px",
    infinite: true,
    responsive: [
      {
        breakpoint: 1930,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 5,
          focusOnSelect: false,
          swipe: true,
        },
      },
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
          focusOnSelect: false,
          swipe: true,
        },
      },
      {
        breakpoint: 1350,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          focusOnSelect: false,
          swipe: true,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          focusOnSelect: false,
          swipe: true,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          swipe: true,
        },
      },

      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          swipe: true,
        },
      },

      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          swipe: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          swipe: true,
        },
      },
    ],
    nextArrow: '<button class="slick-next">Next</button> ',
    prevArrow: '<button class="slick-prev">Previous</button>',
  };

  mostDownloadedProjects: void;
  mostViewedProjects: void;
  organizationId: string;
  organizationName: string;
  organizations: any[] = [];
  specialityList: any;
  restrictDownloadAndMail: boolean;
  displayedVerticalOptions: { name: string; image: string; count: number; }[];
  dialogRef: any;
  kmsViewer: boolean = false;
  totalCaseStudies: number = 1;

  constructor(
    private graphService: GraphService,
    private searchResultsService: SearchResultsService,
    private _http: HttpClient,
    config: NgbTooltipConfig,
    private router: Router,
    // tslint:disable-next-line: max-line-length
    public dialog: MatDialog,
    public snackBar: MatSnackBar,
    private cd: ChangeDetectorRef,
    private projectService: ProjectService,
    private organizationService: OrganizationService,
    private searchPageService: SearchPageService,
    private auth: AuthServiceService,
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer,
    private toastr: ToastrService
  ) {
    this.role = this.auth.getRole();
    this.restrictDownloadAndMail = this.auth.getDownloadAndMailRestriction();
    this.mailMultipleAttachments = new Array<string>();
    this.searchConfig = new SearchTypeModel();
    $('[data-toggle="popover"]').popover();
    $(function () {
      $('[data-toggle="popover"]').popover();
    });
  }
  @HostListener('window:scroll', ['$event'])
  onScroll(event: Event): void {
    const windowHeight = window.innerHeight;
    const scrollY = window.scrollY;
    let bodyHeight = document.body.scrollHeight;
    // Check if user has scrolled to the bottom
    if (scrollY + windowHeight >= bodyHeight - this.threshold) {
      this.loading = true;
      this.from += this.size;
      this.demo.emit(false);
      this.cd.detectChanges();
      if (this.from < this.totalCaseStudies) {
        this.projectService.getProjectsByCaseStudy('Case Studies', this.selectedorganization.name, this.from, this.size).subscribe(
          res => {
            this.bindResults(res, "CaseStudies");
            this.loading = false;
          },
          (error) => {
            this.loading = false;
            this.from -= this.size;
            this.toastr.error("Error while fectching case studies.")
          }
        );
      }
      else {
        this.loading = false;
        this.from -= this.size;
        return;
      }
    }
  }

  dataSource = new MatTableDataSource<AttachmentInfoModel>();

  ngOnInit() {
    if (this.role.includes(UserRoles.Viewer)) {
      this.kmsViewer = true;
    }
    let currentUrl = this.router.routerState.snapshot.url;
    if (currentUrl == "/Home/KMSPortal/Case%20Studies" || currentUrl == "/Home/KMS%20Portal/Case%20Studies" || currentUrl.startsWith("/Home/KMSPortal/Search")) {
      this.flag = false;
      this.extractedString1 = "Case Studies"

    }
    else if (currentUrl.startsWith("/Home/KMSPortal")) {
      const extractedString = currentUrl.substring(currentUrl.indexOf("/Home/KMSPortal/") + "/Home/KMSPortal/".length);
      const decodedString = extractedString.replace(/%20/g, ' ');
      const splitArray = decodedString.split(' ');
      this.extractedString1 = splitArray.join('');
      this.CaseStudy = "Case Studies"
    }
    else if (currentUrl.startsWith("/Home/KMS%20Portal")) {
      const extractedString = currentUrl.substring(currentUrl.indexOf("/Home/KMS%20Portal/") + "/Home/KMS%20Portal/".length);
      const decodedString = extractedString.replace(/%20/g, ' ');
      const splitArray = decodedString.split(' ');
      this.extractedString1 = splitArray.join('');
      this.CaseStudy = "Case Studies"
    }

    this.organizationId = this.auth.getOrganizationName();
    this.organizationName = this.auth.getOrganizationName();

    this.loading = true;
    this.organizationId = this.auth.getOrganizationName();
    this.organizationName = this.auth.getOrganizationName();

    if (this.role.indexOf('CaseStudies.Viewer') < 0 && (this.router.url === '/Home/KMSPortal' || this.router.url === '/Home/KMS%20Portal')) {
      forkJoin([this.projectService.getMostDownloadedProjects(),
      this.projectService.getMostViewedProjects(),
      this.projectService.getGetProjectMetrics()]).subscribe(responses => {
        this.loading = false;
        this.mostDownloadedProjects = responses[0];
        this.mostViewedProjects = responses[1];
        this.specialityList = responses[2];
        if (this.specialityList.length) {
          this.bindCountToVerticalOptions();
        }
        const index = this.organizations.indexOf(
          this.organizations.filter((org) => org.id === this.userOrgID)[0]
        );
        if (index && index >= 0) {
          this.selectedorganization = this.organizations[index];
        }
      },
        (error) => {
          this.loading = false;
        }
      );

      this.organizationService.getUserViewOrganizatons("userId").subscribe(
        (res) => {
        },
        (err) => {
        }
      );
    } else if (this.router.url === "/Home/KMSPortal") {
      forkJoin([
        this.projectService.getMostDownloadedProjects(),
        this.projectService.getMostViewedProjects(),
        this.projectService.getGetProjectMetrics(),
      ]).subscribe(
        (responses) => {
          this.loading = false;
          this.mostDownloadedProjects = responses[0];
          this.mostViewedProjects = responses[1];
          this.specialityList = responses[2];
          if (this.specialityList.length) {
            this.bindCountToVerticalOptions();
          }
        },
        (error) => {
          this.loading = false;
        }
      );
    }
  }
  openInfoDialog(result, action) {
    let myInfo: any = result;

    this.dialogRef = this.dialog.open(this.infoDialog,
      {
        data: { Result: myInfo, Action: action }, height: auto, width: auto,
        minWidth: '550px'
      });


    this.dialogRef.afterClosed().subscribe(() => {
    });
  }
  showAllOptions: boolean = false;
  displayedOptions = [];
  getPosition(element: any) {
    return "screenLeft";
  }
  onChangeProjectType(val: any, verticalValue : string) {
    if (val == "Case Studies") {
      //this.router.navigate(["project/addProject"]);
      if (verticalValue != undefined) {
        this.router.navigate(["Home/KMSPortal/" + verticalValue + "/Add"],{ state: { selectedVertical: verticalValue } });
      } else {
        this.router.navigate(["/Home/KMSPortal/Case Studies/Add"], { state: { selectedVertical: verticalValue } });
      }
    } else {
      // this.router.navigate(["project/ICT/addICTProject"]);

      this.router.navigate(['Home/KMSPortal/Project Content/AddContent']);

    }
  }
  bindCountToVerticalOptions() {
    // Update the code to include a property to track whether all options should be shown
    this.Options.forEach((option) => {
      const info = this.specialityList.find(
        (speciality) => speciality.type === option.name
      );
      option.count = info ? info.count : 0;
    });

    // Filter out options with count === 0
    this.Options = this.Options.filter((opt) => opt.count !== 0);

    // Optionally, if you want to limit the number of displayed options initially
    this.showAllOptions = false; // Set this property to true if you want to show all options initially
    if (!this.showAllOptions && this.Options.length > 8) {
      this.displayedOptions = this.Options.slice(0, 8);
    } else {
      this.displayedOptions = this.Options;
    }
  }

  showSpecialityOptions() {
    // Toggle the visibility flag
    this.verticalOptionsFlag = !this.verticalOptionsFlag;
    // Optionally, update the displayed options based on the flag
    if (!this.showAllOptions && !this.verticalOptionsFlag) {
      this.displayedOptions = this.Options.slice(0, 8);
    } else {
      this.displayedOptions = this.Options;
    }
  }


  fetchResultsByCategory(category) {
    if (category === "Artifactory") {
      this.router.navigate(["/Home/Artifactory"], {
        queryParams: {},
      });
    }
    else {
      this.router.navigate(["/Home/KMSPortal/" + category]);
    }
  }

  navigateToCategory(categoryName: string, category) {
    if (categoryName === 'Templates') {
      this.router.navigate(['/templates']);

    } else {
      this.router.navigate(["/ICT/searchict"], {
        queryParams: { type: category },
      });
    }

  }
  fetchResultsByCaseStudy() {
    this.from = 0;
    this.size = 9;
    this.loading = true;
    this.demo.emit(false);
    this.cd.detectChanges();
    this.searchResultsViewFlag = true;
    this.projectService.getProjectsByCaseStudy('Case Studies', this.selectedorganization.name, this.from, this.size).subscribe(
      res => {
        this.totalCaseStudies = res.total;
        this.bindResults(res, "CaseStudies");
        this.loading = false;
      },
      err => {
        const dialogRef = this.dialog.open(InfoDialogComponent, {
          width: '280px',
          data: { message: 'No files found!', class: 'text-danger' }
        });
        this.loading = false;
        dialogRef.afterClosed().subscribe(() => {
          this.router.navigate(["Home/KMSPortal"])
        });
      }
    );

  }

  downloadFile(attachment, type) {
    if (type == "tcs" && attachment.iFrameURL == null) {

      this.toastr.error("No File to Download");
      return
    }
    if (type == "bcs" && attachment.businessiFrameURL == null) {
      this.toastr.error("No File to Download");
      return
    }
    this.loading = true;
    let documentId =
      type == "tcs" ? attachment.iFrameURL : attachment.businessiFrameURL;
    if (documentId) {
      this.graphService.getDownloadUrl(documentId).subscribe(
        (response) => {
          if (response) {
            const link = document.createElement("a");
            link.setAttribute("type", "hidden");
            link.href = response.url;
            link.download = attachment.attachmentName;
            document.body.appendChild(link);
            this.updateDownloadCount(attachment);
            link.click();
            link.remove();
            this.loading = false;

          } else {
            this.loading = false;
          }
        },
        (err) => {
          this.loading = false;
          const dialogRef = this.dialog.open(InfoDialogComponent, {
            width: "350px",
            data: {
              message:
                "Could not download the file. Please try again after some time or contact administrator",
              class: "text-danger",
            },
          });
        }
      );
    }
  }

  updateDownloadCount(attachment) {
    this.projectService.updateDownloadCount(attachment.id).subscribe(
      (res) => {
        if (res) {
          attachment.downloadCount = attachment.downloadCount + 1;
        } else {
          const dialogRef = this.dialog.open(InfoDialogComponent, {
            width: "350px",
            data: {
              message:
                "Could not update the Download Count. Please try again after some time",
              class: "text-danger",
            },
          });
        }
      }
    );
  }

  getProjectsBySpeciality(speciality: string) {
    this.verticalOption = speciality;
    this.loading = true;
    this.projectService.getProjectsBySpeciality(speciality).subscribe(
      (res) => {
        this.bindResults(res, "");
      },
      (err) => {
        this.searchResultsViewFlag = false;
        this.loading = false;
        const dialogRef = this.dialog.open(InfoDialogComponent, {
          width: "280px",
          data: { message: "No files found!", class: "text-danger" },
        });
        dialogRef.afterClosed().subscribe((res) => {
          this.router.navigate(["Home/KMSPortal"]);
        });
        this.loading = false;
        this.searchResultsViewFlag = false;
      }
    );
  }

  bindResults(res, speciality) {
    if (this.from == 0) {
      this.searchResults = [];
    }
    let listofCaseStudies = null
    if (speciality == "CaseStudies") {
      listofCaseStudies = res.items;
    }
    else {
      listofCaseStudies = res;
    }
    this.loading = false;
    if (listofCaseStudies.length > 0) {
      for (let index = 0; index < listofCaseStudies.length; index++) {
        const result = listofCaseStudies[index];
        if (result) {
          const attachmentInfo = this.prepareAttachmentInfo(result);
          this.searchResults.push(attachmentInfo);
        }
      }
      this.searchResultsViewFlag = true;
      window.scroll(0, 0);
      this.groupSearchFlag = false;
    } else {
      const dialogRef = this.dialog.open(InfoDialogComponent, {
        width: "280px",
        data: { message: "No files found!", class: "text-danger" },
      });
      this.loading = false;

      dialogRef.afterClosed().subscribe((res1) => {
        this.router.navigate(["/Home/KMSPortal"]);
      });
    }

  }

  editProject(val: string, val2: any) {
    const params = { queryParams: { isApproved: true } };
    this.router.navigate([`/Home/KMSPortal/${val2}/editProject/` + val], params);
    this.searchPageService.searchOptions = this.searchConfig;
  }
  goToHome() {
    this.router.navigate(["/Home"]);
  }
  viewFile(attachment, type) {
    if (type == "tcs" && attachment.iFrameURL == null) {

      this.toastr.error("No File to View");
      return
    }
    if (type == "bcs" && attachment.businessiFrameURL == null) {
      this.toastr.error("No File to View");
      return
    }
    const dialogRef = this.dialog.open(ViewfileComponent, {
      width: "900px",
      height: "500px",
      panelClass: "view-file",
      data: {
        Method: "CaseStudies",
        iFrameURL:
          type == "tcs" ? attachment.iFrameURL : attachment.businessiFrameURL,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
    
      this.projectService.updateViewCount(attachment.id).subscribe(
        (res) => {
          if (res) {
           
            attachment.viewCount = attachment.viewCount + 1;
          }
        },
        (err) => {
          this.loading = false;
        }
      );
  
    });
  }

  deleteFile(attachmentId: string) {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: auto,
      minWidth: '500px',
      height: auto,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result.data === "DELETE") {
        this.loading = true;
        this.projectService.deleteProject(attachmentId).subscribe(
          (res) => {
            this.toastr.success("Project deleted  Successfully");
            let speciality: string;
            this.route.paramMap.subscribe((params) => {
              speciality = params.get("speciality");
            });
            setTimeout(() => {
              if (this.router.url === "/Home/KMSPortal/Case%20Studies" || this.router.url === "/Home/KMS%20Portal/Case%20Studies") {
                this.fetchResultsByCaseStudy();
              } else if (this.router.url !== "/Home/KMSPortal") {
                this.searchResultsViewFlag = true;
                this.getProjectsBySpeciality(speciality);
              } else {
                this.searchDoc(this.searchConfig);
              }
            }, 1000);
          },
          (err) => {
            this.loading = false;
          }
        );
      }
    });
  }

  downloadPPts() {
    this.loading = true;
    this.selectedFiles.forEach((file) => {
      this.getSelectedFileRequests.push(
        this.graphService.getFileContent1(
          file.downloadedURL,
          file.attachmentName
        )
      );
    });
    this.downloadAttachments();
  }

  deleteItems() {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '300px',
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result?.data === 'DELETE') {
        this.loading = true;

        this.searchResultsService.delete(this.selectedFiles.map(file => file.id)).subscribe(
          () => {
            this.toastr.success("Project deleted Successfully");
            this.loading = false;

            setTimeout(() => {
              this.getProjectsBySpeciality(this.verticalOption);
            }, 1000); // Set the desired delay time in milliseconds
          },
          (error) => {
            console.error('Error deleting projects:', error);
            this.loading = false;
          }
        );
      }
    });
  }


  downloadAttachments() {
    forkJoin(...this.getSelectedFileRequests).subscribe(
      (res) => {
        const zip = new JSZip();
        // tslint:disable-next-line: prefer-for-of
        for (let i = 0; i < res.length; i++) {
          zip
            .folder(this.selectedFiles[i].deliveryOrganization)
            .file(this.selectedFiles[i].attachmentName + ".pptx", res[i]);
        }
        zip.generateAsync({ type: "blob" }).then(
          (blob) => {
            if (blob && blob !== undefined) {
              const a: any = document.createElement("a");
              document.body.appendChild(a);
              a.style = "display: none";
              const url = window.URL.createObjectURL(blob);
              a.href = url;
              a.download = "download.zip";
              a.click();
              window.URL.revokeObjectURL(url);
              this.loading = false;
            }

            this.selectedFiles.forEach(
              (files) => (files.checked = !files.checked)
            );
            this.selectedFiles = [];
            this.getSelectedFileRequests = [];
            if (this.selectedFiles.length > 0) {
              this.actions.nativeElement.style.right = "0px";
            } else {
              this.actions.nativeElement.style.right = "-300px";
            }
          },
          (err) => {
            this.loading = false;
          }
        );
      },
      (err) => {
        this.loading = false;
      },
      () => { }
    );
  }

  prepareAttachmentInfo(result) {
    const attachmentInfo = new AttachmentInfoModel();
    attachmentInfo.attachmentName = result.fileInfo.fileName;
    if (result.score) {
      attachmentInfo.score = "" + result.score.toFixed(2);
    }
    const url =
      result.fileInfo.fileURL != null ? result.fileInfo.fileURL : null;
    const logoimg = result.fileInfo.caseStudyLogo;
    const logoUrl = result.fileInfo.clientLogo;
    attachmentInfo.downloadedURL = url;
    // tslint:disable-next-line: no-unused-expression
    attachmentInfo.businessiFrameURL = result.fileInfo.bussinessCaseFileURL;
    attachmentInfo.downloadedBusinessURL = result.fileInfo.bussinessCaseFileURL;
    attachmentInfo.iFrameURL = result.fileInfo.fileURL;
    attachmentInfo.bdContact = result.fileInfo.bdContact;
    attachmentInfo.geography = result.fileInfo.geography;
    attachmentInfo.geographyURL = result.fileInfo.geographyURL;
    attachmentInfo.logo = logoUrl;
    attachmentInfo.logoImage = logoimg;
    attachmentInfo.projectManager = result.fileInfo.projectManager;
    attachmentInfo.projectName = result.fileInfo.projectName;
    attachmentInfo.restrictedContent = result.fileInfo.restrictedContent;
    attachmentInfo.id = result.id;
    attachmentInfo.client = result.fileInfo.client;
    attachmentInfo.region = result.fileInfo.region;
    attachmentInfo.base64Content = result.fileInfo.fileBase64Data;
    attachmentInfo.tags = result.fileInfo.tags
      ? result.fileInfo.tags.join(", ")
      : "";
    attachmentInfo.vertical = result.fileInfo.vertical;
    attachmentInfo.projectStatus = result.fileInfo.status;
    attachmentInfo.organizationId = result.fileInfo.organizationId;
    attachmentInfo.organization = this.mapOrganization(
      result.fileInfo.organizationId
    );
    attachmentInfo.deliveryOrganization = result.fileInfo.deliveryOrganization;
    attachmentInfo.businessCaseStudyFlag = result.fileInfo.bussinessCaseFileURL;
    attachmentInfo.viewCount = result.fileInfo.fileViewCount
      ? result.fileInfo.fileViewCount
      : 0;
    attachmentInfo.downloadCount = result.fileInfo.fileDownloadCount
      ? result.fileInfo.fileDownloadCount
      : 0;
    attachmentInfo.checked = false;
    attachmentInfo.bussinessCaseFileName = result.fileInfo.bussinessCaseFileName;
    return attachmentInfo;
  }

  mapOrganization(organizationId) {
    const index = this.organizations.findIndex(
      (ele) => ele.id === organizationId
    );
    if (this.organizations[index] && this.organizations[index].name) {
      return this.organizations[index].name;
    } else {
      return "";
    }
  }

  selectAttachment(attachment: AttachmentInfoModel) {
    if (this.selectedFiles.length < 60) {
      attachment.checked = !attachment.checked;
      if (!this.selectedFiles.includes(attachment)) {
        this.selectedFiles.push(attachment);
      } else {
        const index = this.selectedFiles.indexOf(attachment);
        this.selectedFiles.splice(index, 1);
      }
      if (
        !this.mailMultipleAttachments.includes(attachment.attachmentName) &&
        attachment.attachmentName
      ) {
        this.mailMultipleAttachments.push(
          attachment.deliveryOrganization.replace(" ", "_") +
          "/" +
          attachment.attachmentName
        );
      } else {
        const index = this.mailMultipleAttachments.indexOf(
          attachment.attachmentName
        );
        this.mailMultipleAttachments.splice(index, 1);
      }
    } else {
      ;
      attachment.checked = false;
      this.cd.detectChanges();
      const dialogRef = this.dialog.open(InfoDialogComponent, {
        width: "280px",
        data: {
          message: "Maximum selection limit of 60 has been reached.",
          class: "text-danger",
        },
      });
    }
    if (this.selectedFiles.length > 0) {
      this.actions.nativeElement.style.right = "0px";
    } else {
      this.actions.nativeElement.style.right = "-300px";
    }
  }

  async switchDeckView() {
    this.searchResultsViewFlag = false;
    this.searchPageService.filterButtonFlag = false;
    this.searchPageService.searchTerm = "";
    this.demo.emit(true);
    this.searchPageService.ictSearchTerm = "";
    this.searchPageService.searchOptions.searchTerm = "";
    const currentUrl = this.router.routerState.snapshot.url
    if (currentUrl === "/Home/KMSPortal") {
      window.location.reload()
    }
    await this.router.navigate(["Home/KMSPortal"]);
    window.scroll(0, 0);
  }

  async searchDoc(getSearchOptions: SearchTypeModel) {
    this.searchConfig.searchTerm = getSearchOptions.searchTerm;
    this.searchConfig.filterList = getSearchOptions.filterList;
    this.searchConfig.groupBy = getSearchOptions.groupBy;
    this.searchConfig.operator = getSearchOptions.operator;
    this.searchConfig.activeProjectsFilter =
      getSearchOptions.activeProjectsFilter;
    this.searchConfig.displayType = getSearchOptions.displayType;
    this.searchConfig.vertical = this.verticalOption?this.verticalOption:"";
    this.loading = true;
    
    this.mailMultipleAttachments = [];
    this.selectedFiles = [];

    this.searchResults = [];
    this.groupedSearchResults = [];
    ;
    this.projectService.searchDoc(this.searchConfig).subscribe(
      (res) => {
        const results = res;
        if (results.length > 0) {
          this.searchResultsViewFlag = true;
          window.scroll(0, 0);
          this.selectAllDivFlag = true;
          $("#main").addClass("searchanim");
          $(".bgimg-2").addClass("fade");
          $(".title").addClass("titletoggle");
          // tslint:disable-next-line: only-arrow-functions
          setTimeout(function () {
            $("#main").addClass("reset").removeClass("searchanim");
            $("#mainheader");
            $(".cards_box").addClass("d-block");
          }, 600);
          if (this.searchConfig.groupBy) {
            // tslint:disable-next-line: prefer-for-of
            for (let index = 0; index < res.length; index++) {
              const groupByResult = res[index];
              if (groupByResult) {
                const groupByAttachment = {
                  groupBy: groupByResult.key,
                  attachments: [],
                };
                const results = groupByResult.results;
                if (results.length > 0) {
                  this.searchResults = [];
                  // tslint:disable-next-line: prefer-for-of
                  for (let index = 0; index < results.length; index++) {
                    const result = results[index];
                    if (result) {
                      const attachmentInfo = this.prepareAttachmentInfo(result);
                      groupByAttachment.attachments.push(attachmentInfo);
                    }
                  }
                }
                this.groupedSearchResults.push(groupByAttachment);
                this.groupSearchFlag = true;
              }
            }
            this.cd.detectChanges();
          } else {
            this.searchResults = [];
            // tslint:disable-next-line: prefer-for-of
            for (let index = 0; index < results.length; index++) {
              const result = results[index];
              if (result) {
                const attachmentInfo = this.prepareAttachmentInfo(result);
                this.searchResults.push(attachmentInfo);
              }
            }
            this.groupSearchFlag = false;
            this.cd.detectChanges();
          }
        } else {
          this.searchResults = [];
          this.selectAllDivFlag = false;
          this.searchResultsViewFlag = true;
          this.searchPageService.filterButtonFlag = false;
        }
        this.loading = false;
        this.cd.detectChanges();
      },
      (error) => {
        this.selectAllDivFlag = false;
        this.searchResultsViewFlag = false;
        this.searchPageService.filterButtonFlag = false;
        const dialogRef = this.dialog.open(InfoDialogComponent, {
          width: "280px",
          data: { message: "No files found!", class: "text-danger" },
        });
        dialogRef.afterClosed().subscribe(() => {
          this.router.navigate(["Home/KMSPortal"])
        });
        this.loading = false;
      }
    );
    this.cd.detectChanges();
  }

  // onChangeOrganization for superAdmin
  onChangeOrganization(organization) {
    this.selectedorganization = organization;
  }

  sendMail(attachment: any, multipleCheck: string) {
    const mailOptions = new EmailFileModel(this.auth.getEmailId());
    if (multipleCheck === "single") {
      const selectedMailFile = new FileInfoModel(
        attachment.iFrameURL,
        attachment.attachmentName,
        attachment.deliveryOrganization
      );
      mailOptions.fileInfo.push(selectedMailFile);
    } else {
      this.selectedFiles.forEach((selectedFile) => {
        const selectedMailFile = new FileInfoModel(
          selectedFile.iFrameURL,
          selectedFile.attachmentName,
          selectedFile.deliveryOrganization
        );
        mailOptions.fileInfo.push(selectedMailFile);
      });
    }

    this.loading = true;
    this.graphService.sendEmail(mailOptions).subscribe(
      (res) => {
        this.loading = false;
        const dialogRef = this.dialog.open(InfoDialogComponent, {
          width: "280px",
          data: {
            message: "E-mail sent successfully.",
            class: "text-success",
          },
        });
      },
      (err) => {
        this.loading = false;
        const dialogRef = this.dialog.open(InfoDialogComponent, {
          width: "280px",
          data: {
            message: "Some Error has occurred" + err.message,
            class: "text-danger",
          },
        });
      }
    );
  }
  checkRole(role) {
    return this.role.indexOf(role) >= 0;
  }

  hide() {
    this.actions.nativeElement.style.right = "-300px";
  }
  slickInit(e) {
  }
  breakpoint(e) {
  }

  afterChange(e) {
  }

  beforeChange(e) {
  }
}
